import { Loader } from 'shared/ui/ui-kit';

export const LoadingPage = () => {
  // THIS PAGE SHOULD NOT CONTAIN ANY REACT ROUTER STUFF
  return (
    <div className='flex min-h-screen flex-col'>
      <Loader />
    </div>
  );
};

export default LoadingPage;
